import { IRootState } from '../../../store'
import { IPatientAllergiesOptionsState } from '../store/options.types'

export const getPatientAllergyOptionsSelector = (state: IRootState): IPatientAllergiesOptionsState =>
  state.options.patientAllergiesOptions
